import { OptionProps } from "@digital/ui";
import api, { Notifiable } from "../api";

const controller = '/naoConformidadeAprovadorAlternativo';


export interface AprovadorAlternativoProps {
  id: string;
  colaboradoIntegracaoId: string;
  colaboradoIntegracaoAlternativoId: string;

  colaboradoIntegracaoNome: string;
  colaboradoIntegracaoAlternativoNome: string;
  name: string;
  register: string;
}


export interface AprovadorAlternativoResultProps {
  numeroLinha: number;
  id: string;
  colaboradoIntegracaoId: string;
  colaboradoIntegracaoAlternativoId: string;

  colaboradoIntegracaoNome: string;
  colaboradoIntegracaoAlternativoNome: string;
}


export const getAllAprovadorAlternativo = async () => {
  return await api.get<Array<AprovadorAlternativoResultProps>>(`${controller}`);
}


export const getByIdAprovadorAlternativo = async (id: string) => {
  return await api.get<AprovadorAlternativoResultProps>(`${controller}/${id}`);
}


export const deleteAprovadorAlternativo = async (id: string) => {
  return await api.delete(`${controller}/${id}`);
}


export const postAprovadorAlternativo = async (form: AprovadorAlternativoProps) => {
  return await api.post<Notifiable>(`${controller}`, form);
}